export default __webpack_public_path__ + "static/media/telegram.36bebee5.svg";